import { render, staticRenderFns } from "./DataState.vue?vue&type=template&id=2ab4628c&scoped=true&"
import script from "./DataState.vue?vue&type=script&lang=js&"
export * from "./DataState.vue?vue&type=script&lang=js&"
import style0 from "./DataState.vue?vue&type=style&index=0&id=2ab4628c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab4628c",
  null
  
)

export default component.exports